import { type ProposalSectionActivity } from './proposalEngagement.models';

export const viewsLabel = (count: number) =>
  `${count} view${count === 1 ? '' : 's'}`;

export const formatDuration = (minutes: number): string => {
  if (minutes < 1) {
    return '<1m';
  }
  const totalMinutes = Math.round(minutes);
  if (totalMinutes < 60) {
    return `${totalMinutes}m`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  return mins ? `${hours}h ${mins}m` : `${hours}h`;
};

export const metricLabel = (activity: {
  pageViewCount: number;
  totalMinutesSpent: number;
}) =>
  `${viewsLabel(activity.pageViewCount)} · ${formatDuration(
    activity.totalMinutesSpent
  )}`;

export interface AggregatedOptionActivity {
  optionGuid: string;
  totalMinutesSpent: number;
  pageViewCount: number;
  scrollCount: number;
  clickCount: number;
}

export const aggregateOptionActivity = (
  activity: ProposalSectionActivity[]
): AggregatedOptionActivity[] =>
  Object.values(
    activity
      .filter((a): a is ProposalSectionActivity & { optionGuid: string } =>
        Boolean(a.optionGuid)
      )
      .reduce<Record<string, AggregatedOptionActivity>>((totals, a) => {
        const current = totals[a.optionGuid] ?? {
          optionGuid: a.optionGuid,
          totalMinutesSpent: 0,
          pageViewCount: 0,
          scrollCount: 0,
          clickCount: 0,
        };
        return {
          ...totals,
          [a.optionGuid]: {
            optionGuid: a.optionGuid,
            totalMinutesSpent: current.totalMinutesSpent + a.totalMinutesSpent,
            pageViewCount: current.pageViewCount + a.pageViewCount,
            scrollCount: current.scrollCount + a.scrollCount,
            clickCount: current.clickCount + a.clickCount,
          },
        };
      }, {})
  );
